<template>
  <span>
    <div class="boss-layout-block">
      <div class="boss-text boss-layout boss-layout-gap-between boss-layout-gap-large">
        <div>
          人事担当者
          <select
            v-model="selectedResponsibleStaffId"
            class="boss-input-select"
            data-test="select-responsible-staffs"
            @change="updateResponsibleStaff"
          >
            <option :value="null">―</option>
            <option
              v-for="staff in responsibles"
              :key="staff.id"
              :value="staff.id"
            >
              {{ staff.name }}
            </option>
          </select>
        </div>
        <div class="boss-layout-item-grow">
          <div class="boss-layout boss-layout-top">
            <div class="pega-layout-top-label">備考</div>
            <div class="boss-layout-item-grow">
              <textarea
                :value="remarks"
                :rows="remarksRows"
                class="boss-input boss-input-fill pega-textarea-remarks"
                data-test="text-remarks"
                placeholder="複数行入力が可能です"
                @change="updateRemarks"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="boss-table-wrap">
      <table class="boss-table-4">
        <tr>
          <th>選考フェーズ<span
            v-tooltip="{ content: '選考フェーズの設定・編集は、「各種設定」メニューで行えます。'}"
            class="pega-circle"
            data-test="tooltip-phase"
          >?</span></th>
          <th>選考ステータス<span
            v-tooltip="{ content: '選考ステータスの設定・編集は、「各種設定」メニューで行えます。'}"
            class="pega-circle"
            data-test="tooltip-status"
          >?</span></th>
          <th class="pega-applicant-selection-date">日時</th>
          <th>評価</th>
          <th>評価コメント</th>
        </tr>
        <applicant-selection-outline
          v-for="(selection, i) in selections"
          :key="i"
          :entry-id="entryId"
          :selection="selection"
        />
      </table>
    </div>
  </span>
</template>

<style scoped>
.pega-circle {
  font-size: .7em;
  cursor: pointer;
  margin-left: 5px;
}
</style>
<script>
import ApplicantSelectionOutline from '@/components/molecules/ApplicantSelectionOutline'
import { mapGetters } from 'vuex'
import _ from 'lodash'
import SelectionEventBus from '@/lib/selectionEventBus'

export default {
  components: {
    ApplicantSelectionOutline
  },
  props: {
    entryId: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      selections: [],
      selectedResponsibleStaffId: null,
      remarks: ''
    }
  },
  computed: {
    ...mapGetters('settings', [
      'responsibles'
    ]),
    isOverLengthRemarks () {
      return this.remarks.length > 500
    },
    remarksRows () {
      return _.split(this.remarks, /\n/).length
    }
  },
  watch: {
    entryId: {
      handler () {
        this.fetchSelections()
        this.fetchResponsibleStaff()
        this.fetchRemarks()
      }
    }
  },
  created () {
    this.fetchSelections()
    this.fetchResponsibleStaff()
    this.fetchRemarks()
    SelectionEventBus.onSelectionUpdate(this.fetchSelections)
  },
  beforeDestroy () {
    SelectionEventBus.$off('selection-update')
  },
  methods: {
    updateResponsibleStaff () {
      this.$http.secured.put('/entry/view/entries/responsible_staffs', {
        entryIds: [this.entryId], itemId: this.selectedResponsibleStaffId
      }).then(response => {
        this.$toasted.global.success({ message: '人事担当を更新しました。' })
      })
    },
    updateRemarks (e) {
      this.$set(this, 'remarks', e.target.value)
      this.$http.secured.put('/entry/view/entries/remarks', {
        entryIds: [this.entryId], remarks: this.remarks
      }).then(response => {
        this.$toasted.global.success({ message: '備考を更新しました。' })
      })
    },
    fetchSelections () {
      this.$http.secured.get(`entry/view/entries/${this.entryId}/selection_phases`)
        .then(response => {
          this.$set(this, 'selections', response.data)
        })
    },
    fetchResponsibleStaff () {
      this.$http.secured.get(`/entry/view/entries/${this.entryId}/responsible_staff`).then(response => {
        this.selectedResponsibleStaffId = _.get(response.data, 'id', null)
      })
    },
    fetchRemarks () {
      this.$http.secured.get(`/entry/view/entries/${this.entryId}/remarks`).then(response => {
        this.remarks = response.data
      })
    }
  }
}
</script>
